import { z } from 'zod';
/**
 * `summary_ua` — the ingest bot's lot digest ("Що варто знати"), sent as
 * `summaryUa` on POST /vehicles/ingest and stored verbatim on alpicar_cars.
 *
 * Same split as `market-ua.ts`: the ingest contract keeps the block opaque so
 * the bot can grow it; THIS schema is the read side, and `parseSummaryUa`
 * decides whether the lot page has something real to draw. Ukrainian only —
 * the bot writes no other language.
 *
 * Not to be confused with `ai.summaryUa` on the same payload: a plain string
 * that lands in ai_car_analysis.
 */
export const SummaryUaSchema = z
    .object({
    title: z.string().nullish(),
    /** 0–100, the bot's own confidence in the digest. */
    confidence: z.number().min(0).max(100).nullish(),
    /** "На основі 31 фото, опису стану від продавця та 26 оголошень AUTO.RIA." */
    basis: z.string().nullish(),
    bullets: z.array(z.string()),
    /**
     * rules-v2: a short opinion on the lot (damage, repair difficulty in
     * Ukraine, rough cost, the AUTO.RIA market) — drawn as a paragraph above the
     * bullets. Absent in rules-v1.
     */
    opinion: z.string().nullish(),
    /**
     * rules-v1: the whole digest as one preformatted string (title, confidence
     * and bullets again); rules-v2: equal to `opinion`. Never drawn — read
     * `opinion`, or a v1 lot would print its bullets twice.
     */
    text: z.string().nullish(),
    /** How the digest was produced, e.g. "rules-v1". */
    method: z.string().nullish(),
    factors: z.array(z.string()).nullish(),
})
    .passthrough();
/**
 * Narrow a stored `summary_ua` to a drawable digest, or `null`.
 *
 * Blank bullets are dropped; a digest with none left is `null`, so the page
 * falls back to the lines it builds from the lot itself rather than drawing an
 * empty list under a confidence chip.
 */
export function parseSummaryUa(raw) {
    const parsed = SummaryUaSchema.safeParse(raw);
    if (!parsed.success)
        return null;
    const bullets = parsed.data.bullets.map((line) => line.trim()).filter(Boolean);
    if (bullets.length === 0)
        return null;
    const opinion = parsed.data.opinion?.trim() || undefined;
    return { ...parsed.data, bullets, opinion };
}
//# sourceMappingURL=summary-ua.js.map